var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.lastSeenItems && _vm.lastSeenItems.length > 0
    ? _c("div", { staticClass: "crosselling-list-overlay__content" }, [
        _c(
          "p",
          {
            staticClass:
              "crosselling-list-overlay__headline h4 font-weight-bold mb-3"
          },
          [
            _vm._v(
              _vm._s(
                _vm.$translate(
                  "KMSVueTheme::SingleItemTheme.ATBLastSeenItemsHeadline"
                )
              )
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "crosselling-list-overlay__grid" },
          _vm._l(_vm.itemsToShow, function(item) {
            return _c(
              "div",
              { key: item.id, staticClass: "crosselling-list-overlay__item" },
              [
                _c(
                  "category-item",
                  {
                    attrs: {
                      "decimal-count": _vm.$ceres.config.item.storeSpecial
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "before-prices",
                          fn: function() {
                            return [
                              _c("div", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.getContainerContentById(
                                      item.id,
                                      "beforePrices"
                                    )
                                  )
                                }
                              })
                            ]
                          },
                          proxy: true
                        },
                        {
                          key: "after-prices",
                          fn: function() {
                            return [
                              _c("div", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.getContainerContentById(
                                      item.id,
                                      "afterPrices"
                                    )
                                  )
                                }
                              })
                            ]
                          },
                          proxy: true
                        },
                        {
                          key: "item-data",
                          fn: function() {
                            return [_vm._v(_vm._s(item.data))]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      true
                    )
                  },
                  [
                    _vm._v(" "),
                    _vm._v(" "),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "small",
                        attrs: { href: _vm.getItemUrl(item.data) }
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-image",
                          attrs: { "aria-hidden": "true" }
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(_vm.getItemName(item.data)))])
                      ]
                    )
                  ]
                )
              ],
              1
            )
          }),
          0
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }